import React from "react"
import PropTypes from "prop-types"
import { useParams, Redirect } from "react-router-dom"
import InventoryExploreChartOrganism from "views/organisms/canvases/charts/analytics/InventoryExploreChartOrganism"
import CSRExploreChartOrganism from "views/organisms/canvases/charts/analytics/CSRExploreChartOrganism"
import CSRDExploreChartOrganism from "views/organisms/canvases/charts/analytics/CSRDExploreChartOrganism"
import WorkplaceExploreChartOrganism from "views/organisms/canvases/charts/analytics/WorkplaceExploreChartOrganism"
import InfrastructureExploreChartOrganism from "views/organisms/canvases/charts/analytics/InfrastructureExploreChartOrganism"
import NetworkExploreChartOrganism from "views/organisms/canvases/charts/analytics/NetworkExploreChartOrganism"
import classNames from "classnames"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"
import { useAppContext } from "components/AppContext"

const Objective13AnalyticsOrganism = ({ children }) => {
  const { themeId } = useParams()
  const { currentNode } = useAppContext()

  const analyticsSwitch = (themeId) => {
    switch (themeId) {
      case "workplace":
        return <WorkplaceExploreChartOrganism />
      case "infrastructure":
        return <InfrastructureExploreChartOrganism />
      case "network":
        return <NetworkExploreChartOrganism />
      case "websites":
        if (
          (currentNode?.id === 2912 && currentNode?.name === "FR") ||
          (currentNode?.id === 2911 && currentNode?.name === "eSNCF Solutions")
        ) {
          return (
            <div className="Verdikt-Score">
              <div className={classNames("environmental", "page-frame")}>
                <div className="page">
                  <MetabaseChartMolecule verdikt_alias="dashboard_explore_mono_app" />
                </div>
              </div>
            </div>
          )
        }
        return <Redirect to="/explore/environmental/13/workplace" />
      case "inventory":
        return <InventoryExploreChartOrganism />
      case "csrd":
        return <CSRDExploreChartOrganism />
      // case "csr":
      //   return <CSRExploreChartOrganism />
      default:
        return <Redirect to="/explore/environmental/13/workplace" />
    }
  }

  return (
    <>
      {analyticsSwitch(themeId)}
      {children}
    </>
  )
}

Objective13AnalyticsOrganism.propTypes = {
  children: PropTypes.node,
}

export default Objective13AnalyticsOrganism
